import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { parseUrlParams } from 'utils/parseUrlParams';
import ContentWrapper from 'components/ContentWrapper';
import imgError from 'assets/images/error.svg';
import {
  newNextAction,
  NEW_NEXT,
  randomNextAction,
  RANDOM_NEXT,
} from '../../actions/navigation';

import Transition from '../../components/Transition';
import { useConfig } from '../../config/ConfigContext';
import Header from '../../components/Header';
import Modal from '../../components/Modal';
import './style.scss';

const Microbilt = (props) => {
  const config = useConfig();
  const [microbiltHeight, setMicrobiltHeight] = useState(0);
  const [isConsentModalVisible, setIsConsentModalVisible] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const microbiltContainerRef = useRef(null);

  const onMessageReceived = (event) => {
    const { data } = event;
    const { dispatch } = props;
    const params = parseUrlParams(window.location.search);

    if (data.microbiltComplete) {
      if (params.key) {
        dispatch(newNextAction({
          key: params.key,
          workflowType: 'microbilt',
          data: {},
          fail: (err) => {
            console.log(err);
            setIsPopupVisible(true);
          },
        }));
      }
    }
  };

  useEffect(() => {
    window.addEventListener('message', onMessageReceived, false);

    const { navigate, checkinData } = props;

    const params = parseUrlParams(window.location.search);

    const sourceData = get(checkinData, 'data', null) || get(checkinData, 'state.data', null);
    if (!sourceData) {
      navigate(`/microbilt/welcome/?key=${params.key}`);
    }

    if (microbiltHeight === 0) {
      setMicrobiltHeight(microbiltContainerRef.current.clientHeight - 50);
    }

    return () => {
      window.removeEventListener('message', onMessageReceived, false);
    };
  }, []);

  useEffect(() => {
    const { fetch, navigate, checkinData, dispatch } = props;

    if (fetch.isDone[`${RANDOM_NEXT}`] && !fetch.isRunning[`${RANDOM_NEXT}`]) {
      if (get(checkinData, 'data.data.nextAction.path') || get(checkinData, 'state.data.nextAction.path')) {
        dispatch(randomNextAction({
          rawUrl: get(checkinData, 'data.data.nextAction.path') || get(checkinData, 'state.data.nextAction.path'),
          data: {},
        }));
      } else if (get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path')) {
        dispatch(randomNextAction({
          rawUrl: get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path'),
          data: {},
        }));
      } else if (get(checkinData, 'data.url') || get(checkinData, 'state.url')) {
        const url = get(checkinData, 'data.url') || get(checkinData, 'state.url');
        const routeUrl = url.replace(config.hostUrl, '');
        navigate(routeUrl);
      }
    } else if (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) {
      if (get(checkinData, 'data.data.nextAction.path') || get(checkinData, 'state.data.nextAction.path')) {
        dispatch(randomNextAction({
          rawUrl: get(checkinData, 'data.data.nextAction.path') || get(checkinData, 'state.data.nextAction.path'),
          data: {},
        }));
      } else if (get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path')) {
        dispatch(randomNextAction({
          rawUrl: get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path'),
          data: {},
        }));
      } else if (get(checkinData, 'data.url') || get(checkinData, 'state.url')) {
        const url = get(checkinData, 'data.url') || get(checkinData, 'state.url');
        const routeUrl = url.replace(config.hostUrl, '');
        navigate(routeUrl);
      }
    }
  }, [props.checkinData]);

  const handleAgreeButtonClick = (e) => {
    e.preventDefault();

    setIsConsentModalVisible(false);
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

  const handleVerifyLater = () => {
    const { dispatch } = props;
    const params = parseUrlParams(window.location.search);
    if (params.key) {
      dispatch(newNextAction({
        key: params.key,
        workflowType: 'microbilt',
        data: {
          skip: true,
        },
        fail: (err) => {
          console.log(err);
          setIsPopupVisible(true);
        },
      }));
    }
  };

  const { checkinData } = props;
  return (
    <Transition className="transition-item wrapper vh-100">
      <Header />
      <ContentWrapper className="mh-20 microbilt-wrapper">
        <div className="microbilt-container container" ref={microbiltContainerRef}>
          <div className="verifyManual" onClick={handleVerifyLater}>Verify Manually</div>
          {/* <iframe
            title="microbilt verification"
            src="https://sdkstage.microbilt.com/WebServices/IBV2/IBV2019/AccountVerification?reference={617CC960-A9E3-44E9-A7B2-E10030E7788F}"
            width="100%"
            height={microbiltHeight}
            frameBorder="0"
            style={{ overflow: 'hidden' }}
          /> */}
          {
            (checkinData.data || checkinData.state) && (
              <iframe
                title="microbilt verification"
                src={`${get(checkinData, 'data.data.microBiltUrl') || get(checkinData, 'state.data.microBiltUrl')}`}
                width="100%"
                height={microbiltHeight}
                frameBorder="0"
                style={{ overflow: 'hidden' }}
              />
            )
          }
        </div>
      </ContentWrapper>
      {
        isConsentModalVisible
          && (
          <Modal>
            <div className="card-header">
              {// eslint-disable-next-line jsx-a11y/control-has-associated-label
                <button className="close" type="button" onClick={handleAgreeButtonClick} />
              }
              <h5>Income Verification</h5>
            </div>
            <div className="card-content error-modal">
              <p className="sub-title mb-1">LendingUSA uses Microbilt to verify your income.</p>
              <h2 className="text-center mb-3 popup-content">
                Please select ALL bank institutions and bank accounts that contain your income deposits.
              </h2>
              <div onClick={handleAgreeButtonClick} className="btn btn-green">Continue</div>
            </div>
          </Modal>
          )
        }
      {
        isPopupVisible
          && (
          <Modal>
            <div className="card-content error-modal security-error">
              <img src={imgError} alt="" />
              <p>Please try again.</p>
              <div onClick={handleClosePopup} className="btn btn-red">OK</div>
            </div>
          </Modal>
          )
      }
    </Transition>
  );
};

Microbilt.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  fetch: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(Microbilt);
